/**
 * OracleHeader.tsx - Query display (Summary-card header)
 *
 * Renders the user's query inside the Summary card. Classification badges
 * (reasoning type, direction, complexity) and the schemas chip strip were
 * removed in iteration 2: they were engineering-vocabulary noise that didn't
 * help an advisor defend a recommendation in front of a client. The activated
 * schemas appear as human-readable names ("Customer Economics", "BSC Vertical
 * Causation") inside the Reasoning → Explanation accordion below.
 */

import type { OracleResponse } from '@models/oracle'
import './OracleHeader.css'

interface OracleHeaderProps {
  response: OracleResponse
}

function OracleHeader({ response }: OracleHeaderProps) {
  return (
    <div className="oracle-header">
      <p className="query-text">{response.query}</p>
    </div>
  )
}

export default OracleHeader
